module.exports = __webpack_public_path__ + "img/worm2.d5b7140e.svg";